import { Box, Typography } from "@mui/material";
import Style from '../../SipocDiagram.module.css';


interface SipocModalAdminProps {
  businessDescData: any;

}



const BusinessDescription: React.FC<SipocModalAdminProps>  = ( {businessDescData} ) => {
  return (
   <>
    <Typography variant="h6">SIPOC Diagram</Typography>
            <Box
              className={Style.scrollableContent}

              sx={{ display: "flex", justifyContent: "space-between" }}>
              <Box sx={{ flex: 1, pr: 2 }}>
                <Box>
                <Typography variant="h5" className={Style.spoicdatatitle} pt={2}>Clients</Typography>
                <Typography className={Style.spoicdatatext}>
                  {businessDescData.clients.split('|').map((client: string, index: number) => (
                    <span key={index}>{client.trim()}<br /></span>
                  ))}
                </Typography>
               </Box>
               <Box>
                <Typography variant="h5" className={Style.spoicdatatitle} pt={2}>Inputs</Typography>
                <Typography className={Style.spoicdatatext}>  {businessDescData.inputs.split('|').map((input: string, index: number) => (
                  <span key={index}>{input.trim()}<br /></span>
                ))}</Typography>
                </Box>
                <Box>
                <Typography variant="h5" className={Style.spoicdatatitle} pt={2}>Processes</Typography>
                <Typography className={Style.spoicdatatext}>  {businessDescData.processes.split('|').map((process: string, index: number) => (
                  <span key={index}>{process.trim()}<br /></span>
                ))}</Typography>
                </Box>
              </Box>
              <Box sx={{ flex: 1, pl: 2 }}>
                <Typography variant="h5" className={Style.spoicdatatitle} pt={2}>Outputs</Typography>
                <Typography className={Style.spoicdatatext}>  {businessDescData.outputs.split('|').map((output: string, index: number) => (
                  <span key={index}>{output.trim()}<br /></span>
                ))}</Typography>
                <Typography variant="h5" className={Style.spoicdatatitle} pt={2}>Suppliers</Typography>
                <Typography className={Style.spoicdatatext}>{businessDescData.suppliers}</Typography>
              </Box>


            </Box>
   </>
  )
}

export default BusinessDescription